import { useState } from "react";
import React from 'react'
import styled from "styled-components";
import { ReactSVG } from 'react-svg'
import QuesImg1 from '@/assets/svg/ques.svg'
import USDCImg from '@/assets/imgs/usdc.png'
import { useAccount, useBalance, useContractWrite, useContractReads } from "wagmi";
import DebtModal from "@/components/TotalDebt/Modal";
import StakeModal from "@/components/StakeModal/Modal";
import RedeemModal from "@/components/Redeem/Modal";
import UnstakeModal from "@/components/UnstakeModal/Modal";
import { ethers } from "ethers";
import BorrowModal from "@/components/BorrowModal/Modal";
import { numberWithCommas } from '@/utils/index'
import { jungleAbi, JungleCA, USDCCA, usdcAbi } from '@/utils/abi'
import { useEffect } from "react";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { useMemo } from "react";
import { useToastContext } from "@/contexts/ToastContext";
import { arbitrumGoerli } from 'wagmi/chains'

export default function Staked() {
  const { address } = useAccount();  
  const { showToast } = useToastContext();
  
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);  
  const [isOpen3, setIsOpen3] = useState(false);  
  const [isOpen4, setIsOpen4] = useState(false);  
  const [isOpen5, setIsOpen5] = useState(false);  
  const [borrowObj, setBorrowObj] = useState({});  
  const [unstakeObj, setUnstakeObj] = useState({});  
  const [stakedU, setStakedU] = useState('0.00'); 

  const jungleContract = {
    address: JungleCA,
    abi: jungleAbi
  }
  
  const { writeAsync:usdcWriteAsync } = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: USDCCA,
    abi: usdcAbi,
    functionName: 'mint',
    chainId: arbitrumGoerli.id,
    args: [ethers.utils.parseUnits('10000', 18)],
  })

  let { data:personData } = useContractReads({
    contracts: [
      {
        ...jungleContract,
        functionName: 'collateralSolid',
        args: [address],
      },
      {
        ...jungleContract,
        functionName: 'debtBalanceOf',
        args: [0, address],
      },
      {
        ...jungleContract,
        functionName: 'holdingVal',
        args: [0, address],
      },      
      {
        ...jungleContract,
        functionName: 'jUSDSolidBalanceOf',
        args: [address],
      },
      {
        ...jungleContract,
        functionName: 'collateralLiquid',
        args: [0, address],
      }
    ],
    onError(error) {
      console.log('Error', error)
    },
    watch: true,
  })
  personData = personData || []
  
  const [stakedValue, PersonDebt, SynthValue, solidJUSDBalance, collateralLiquid] = (personData.filter(i => i).length && personData || Array(5).fill(0)).map(ethers.utils.formatEther)  

  const listData = (personData || []).map(_ => ethers.utils.formatEther(_ || 0))
  
  const unrealizedPnl = useMemo(() => {
    if(collateralLiquid == 0) return '0.0'
    return parseFloat(( SynthValue - PersonDebt) / collateralLiquid * 100 ).toFixed(2)
  }
  , [personData]);
  
  const isShowMore = useMemo(() => {
    const delta =  ((SynthValue - PersonDebt ) / collateralLiquid)
    return delta < 0 && (Math.abs(delta) * 100 > 79)
  }
  , [personData]);
  
  const borrowHandler = (obj)=>{
    setIsOpen2(false)
    setIsOpen4(true)
    setBorrowObj(obj)
  }
  const successCb = ()=>{
    setIsOpen4(false)
    setIsOpen5(false)
  }
  const borrowError = ()=>{
    setIsOpen4(false)
  }

  const handleClaim = async()=>{
    if(data?.formatted > 0) return    
    try {
      const fucker = await usdcWriteAsync()
      const waitData = await fucker.wait()
      if(waitData?.status === 1){        
        showToast({
          dir:'top',
          type:'success',
          text:'10000 USDC Claimed!'
        })
      }      
    } catch (error) {
      
      showToast({
        dir:'top',
        type:'error',
        text:'Fail，Please try again'
      })
    }

  }
  
  const clickCb = (obj)=>{
    setIsOpen3(false)
    setUnstakeObj(obj)
    setIsOpen5(true)
  }
  
  useEffect(() => {
    if(stakedValue){     
      setStakedU(ethers.utils.formatEther( data?.[0] || 0 ))  
    }
  }, [stakedValue])
  
  
  const { data, isError, isLoading } = useBalance({
    address: address,
    token: USDCCA,
    watch: true
  })  

  return (
    <>
      <Comp>
        <div className='container'>
          <div className='p-title'>My Jungle</div>
          <div className='common-block stake-block'>
            <div className='top'>
              <div className='top-left'>
                <span className='l-t'>MAX Redeemable Value</span>
                <span className='l-b'>${(+stakedValue).toFixed(2)}</span>
              </div>
              <div className="top-center">
                <span className='l-t'>Solid JUSD</span>
                <span className='l-b'>${(+solidJUSDBalance).toFixed(2)}</span>                
              </div>
              <div className='top-right'>
                <div className='r-t'>
                  <span>Borrow JUSD by staking your asset</span>
                  <ReactSVG id="my-element1" src={QuesImg1} className="fifth-svg" beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                  <ReactTooltip style={{'width':'300px', 'background': '#4B4B4B','borderRadius': '8px', 'lineHeight': '20px', 'padding':'16px'}} anchorId="my-element1" place="bottom" content="To borrow JUSD, stake your USDC at a ratio of 1:1. To unstake and claim your USDC, Conditions for Withdrawals must be met." />
                </div>
                <div className='r-b' onClick={() => setIsOpen2(true)}>Stake</div>
              </div>
            </div>
            <div className='line'></div>
            <div className='line2'></div>
            <div className='bot'>
              <div className='l'>
                <div className='l-t'>
                  <span>${(+PersonDebt).toFixed(2)}</span>
                </div>
                <div className='l-b'>Personal Total Debt</div>
              </div>
              <div className='c'>
                  <span>${numberWithCommas(SynthValue)}</span>
                  <span className='fifth'>Synth Vaule in Debt Pool</span>
              </div>
              <div className='r'>
                  <span className={`gr ${ +unrealizedPnl < 0 ? 'warning-text':'' }`}>{unrealizedPnl}%</span>
                  <div className="r-gr">
                    <span className='fifth'>unrealized PNL</span>
                    <ReactSVG id="my-element2" src={QuesImg1} className="fifth-svg" beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                    <ReactTooltip style={{'width':'300px', 'background': '#4B4B4B','borderRadius': '8px', 'fontSize': '14px', 'lineHeight': '20px', 'padding':'16px'}} anchorId="my-element2" place="bottom" content="Unrealized PnL% = （Synth Value - Total Debt）/ Staked Value in Debt Pool" />
                  </div>
              </div>
            </div>
            {isShowMore &&  <div className="desc">
              {/* <ReactSVG className="ques-img" src={QuesImg2} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/> */}
              <div className="desc-content">
                Your collaterals are in the risk of liquidation! To avoid this happening, please repay your debt by selling off some synths or <span className="green-txt" onClick={() => setIsOpen2(true)}>staking more USDC.</span> 
              </div>
            </div>}
          </div>
          <div className="claim-wrapper">
            <span className="usdc">USDC</span>
            <span className="claim-txt">Claim your test token</span>        
            <div className={`r-b ${data?.formatted > 0 ? 'claimed' : ''}` } onClick={handleClaim}>{ data?.formatted > 0 ? 'Already Claimed' : 'Claim'}</div>
          </div>
          <div className='p-title2'>My Wallet</div>
          <div className='common-block token-block'>
            <div className='table'>
              <div className='title'>
                <div className='flex-1 flex-left'>Token</div>
                <div className='flex-1'>Balance</div>
                <div className='flex-1 rr-gr'>
                  <span className='fifth'>Amount</span>
                  {/* <ReactSVG id="my-element3" src={QuesImg1} className="fifth-svg" beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/> */}
                  {/* <ReactTooltip style={{'width':'300px', 'background': '#4B4B4B','borderRadius': '8px', 'fontSize': '14px', 'lineHeight': '20px', 'padding':'16px'}} anchorId="my-element3" place="bottom" content="Unrealized PnL% = （Synth Value - Total Debt）/ Staked Value in Debt Pool" /> */}
                </div>
                <div className='flex-1 flex-right'>Action</div>
              </div>
              <div className='content'>
                <div className='list-item'>
                  <div className='flex-1 token-item'>
                    <img className="token-logo" src={USDCImg} alt="" />
                    <div className='token'>
                      <div className='token-title'>USDC</div>
                      <div className='token-desc'>USD Coin</div>
                    </div>
                  </div>
                  <div className='flex-1 money'>${numberWithCommas(data?.formatted)}</div>
                  <div className='flex-1 money'>${numberWithCommas(stakedValue)}</div>
                  <div className='flex-1 btns'>
                    <div className='btn unstake' onClick={() => setIsOpen3(true)}>Unstake</div>
                    <div className='btn stake' onClick={() => setIsOpen2(true)}>Stake</div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </Comp>
      <DebtModal handleClose={() => setIsOpen(false)} isOpen={isOpen} balanceObj={stakedU}/> 
      <StakeModal handleClose={() => setIsOpen2(false)} isOpen={isOpen2} balanceObj={data} borrowHandler={borrowHandler} successCb={successCb} borrowError={borrowError} debt={listData}/> 
      <BorrowModal isOpen={isOpen4} handleClose={() => setIsOpen4(false)} borrowObj={borrowObj}/>

      <RedeemModal handleClose={() => setIsOpen3(false)} isOpen={isOpen3} usdcBalannce={solidJUSDBalance} clickCb={clickCb} successCb={successCb} borrowError={borrowError} debt={listData}/> 
      <UnstakeModal isOpen={isOpen5} handleClose={() => setIsOpen5(false)} unstakeObj={unstakeObj}/>
    </>
  )
}
const Comp = styled.div`
  display: flex;  
  .rr-gr{
    display: flex;
    align-items: center;
    .fifth{
      padding-left:16px;
      padding-right: 4px;
    }
  }
  .container{
    min-width: 1074px;
    width: 100%;
    margin-right: 10vw;
    .fifth-svg{
      cursor: pointer;                
      display: flex
    }
    .p-title2{
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.6);
      padding-left:8px;
      padding-top:30px;      
    }
    .p-title{
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.6);
      padding: 28px 0 16px 8px;     
    }
  }
  .r-b{
      background: #32DE86;
      border-radius: 8px;
      width: 130px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;          
      color: #FFFFFF;          
      margin-top: 17.5px;
      cursor: pointer;       
      &:hover{
        background:#239B5E; 
      }
    }
    .claim-wrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 80px;
        background: rgba(50, 222, 134, 0.2);
        border-radius: 8px;
        margin-top: 30px;
        padding: 0 34px 0 30px;
      .usdc{
        font-weight: 500;
        font-size: 26px;        
      }
      
      .claim-txt{
        font-weight: 500;
        font-size: 17px;
      }
      .r-b{
        margin-top: 0;    
        &.claimed{
          font-size: 15px;
          color: rgba(255, 255, 255, 0.3);
          background: rgba(50, 222, 134, 0.3);
          cursor: auto;
        }
      }
    }
  .common-block{
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
  }
  
  .stake-block{
    padding: 24px 52px 31px 31px;
    position: relative;
    .top {
      display: flex;
      justify-content: space-between;
      .top-left{
        display: flex;
        flex-direction: column;
        .l-t{
          font-size: 14px;
          line-height: 20px;          
          color: rgba(255, 255, 255, 0.6);
        }
        .l-b{
          font-weight: 600;
          font-size: 40px;
          line-height: 56px;
          padding-top: 17px;          
        }
      }
      .top-center{
        display: flex;
        flex-direction: column;                   
        font-size: 20px;
        margin-left: 80px;
        
        .l-t{
          font-size: 14px;
          line-height: 20px;          
          color: rgba(255, 255, 255, 0.6);
        }
        .l-b{
          font-weight: 600;
          padding-top: 17px;
          font-size: 40px;
          line-height: 56px;
          color: #fff;
        }
      }
      
      .top-right{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .r-t{
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;          
          color: rgba(255, 255, 255, 0.6);

          span{
            margin-right: 8px;
            color: #A8B3AE;
          }
        }
       
      }
    }
    .line {
      height:74px      
    }
    .line2{
      position: absolute;
      left: 0;
      top: 169px;
      width: 100%;
      border: 0.5px solid rgba(255, 255, 255, 0.1);
    }
    .bot{
      display: flex;
      .c, .r{
        margin-left:20%;
      }
      .l{
        display: flex;
        align-items: center;
        flex-direction: column;          
        .l-t{
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 22px;
          line-height: 32px;  
          color: #F3F7F6;   
          span{
            padding-right:6px;
          }       
        }
        .l-b{
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          line-height: 20px;
        }
      }
      .c{
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 600;
        font-size: 22px;
      }
      .fifth{
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.6);
      }
      .r{
        display: flex;
        flex-direction: column;        
        align-items: center;
        padding-right: 85px;
        font-weight: 600;
        font-size: 22px;
        .gr{
          color: #21B36C;      
          &.warning-text{
            color: #FF8A00;
          }
        }
        .r-gr{
            display: flex;
            align-items: center;
            .fifth{
              padding-right:8px;             
            }            
          }
      }
    }
    .desc{
      background: #282828;
      padding-left: 18px;
      border-radius: 9px;
      line-height: 50px;
      height: 50px;
      display: flex;
      margin-top: 43px;
      .ques-img{
        align-self: flex-start;
        margin-top:16px;
        margin-right:12px;
      }
      .desc-content{
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        line-height: 50px;
        height: 50px;        
      }

      .green-txt{
        color: #FF8A00;
        cursor: pointer;
      }
     
      
    }
  }

  .token-block{
    margin-top:16px;
    padding: 24px 0 8px 0;
    margin-bottom: 30px;
  }
  .table{
    font-size: 16px;
    color: #F3F7F6;
    .title{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 1;
      padding: 0 43px 0 30px;
      font-weight: 600;
      line-height: 20px;      
      color: rgba(255, 255, 255, 0.6);      
      .flex-1{
        flex: 1;
        display: flex;
        justify-content: center;
      }      
      .flex-left{
        justify-content: flex-start;
      }
      .flex-right{
        justify-content: flex-end;
      }
    }
    .content{

    }
    .list-item{
      height: 69px;
      line-height: 69px;
      display: flex;
      justify-content: space-between;
      padding-left:30px;
      padding-right:34px;
      & + .list-item{
        border-top:1px solid rgba(255, 255, 255, 0.1);
      }
      .flex-1{
        flex: 1;
      }
      .token-item{
        display: flex;
        align-items: center;
        .token-logo{
          width: 32px;
          height: 32px;
          border-radius:52%;
          background: #D9D9D9;
          margin-right:12px;
        }
      }
      .token{
        display: flex;
        flex-direction: column;
        line-height: 1;
        .token-title{
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
        }
        .token-desc{
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
      .money{          
          display: flex;
          justify-content: center;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
        }
      .btns{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .btn{
          height: 33px;
          width: 70px;
          line-height: 33px;
          text-align: center;
          font-weight: 600;
          font-size: 16px;
          color: #fff;
          border-radius: 8px;
          cursor: pointer;
        }
        .stake{
          color: #fff;
          background: #32DE86;
          &:hover{
            background:#239B5E; 
          }
        }
        .unstake{
          width: 89px;
          background: #FF8A00;
          color: #fff;
          margin-right: 21px;
          &:hover{
            background:#B36100;
          }
        }

      }
    }
  }
`

